export class CtNavKeys {
  static Home = 'home';
  static Workspaces = 'workspaces';
  static ModelVersions = 'model-versions';
  static Measurements = 'measurements';
  static Map = 'map';
  static AdministrationModule = 'administration';
  static Users = 'users';
  static Groups = 'groups';
}
